<script lang="ts">
	import Button from "@components/common/Button.svelte";
	import Icon from "@components/common/Icon.svelte";
	import Link from "@components/common/Link.svelte";
	import { ButtonVariant } from "@components/common/getButtonClass.js";
	import { onMount } from "svelte";
	import logo from "../../../../core/assets/icons/zms-logo.svg?raw";
	import closeIcon from "@core/assets/icons/close.svg?raw";
	import menuIcon from "@core/assets/icons/menu.svg?raw";
	import type { MenuItem } from "@core/schema/MenuItem.js";
	import { getHomepagePath } from "@core/schema/paths/getHomepagePath.js";
	import { getGlobalTemplateProps } from "../../contexts/getGlobalTemplateProps.js";
	import { lockScroll } from "../../state/lockScroll.svelte.js";
	import Menu from "./Menu.svelte";

	const { menu }: { menu: MenuItem[] } = $props();
	const { tenant } = getGlobalTemplateProps();

	let headerHeight = $state(0);
	let mobileMenuOpen = $state(false);
	let isVisible = $state(true);
	let lastScrollY = $state(0);
	let showShadow = $state(false);

	onMount((): (() => void) => {
		const SHADOW_THRESHOLD = 10;
		const HIDE_THRESHOLD = 80;

		function handleScroll(): void {
			if (lockScroll.lock) {
				return;
			}

			const currentScrollY = window.scrollY;

			showShadow = currentScrollY > SHADOW_THRESHOLD;

			if (currentScrollY < lastScrollY || currentScrollY < HIDE_THRESHOLD) {
				isVisible = true;
			} else if (currentScrollY > lastScrollY && currentScrollY > HIDE_THRESHOLD) {
				isVisible = false;
			}

			lastScrollY = currentScrollY;
		}

		window.addEventListener("scroll", handleScroll, { passive: true });

		return () => {
			window.removeEventListener("scroll", handleScroll);
		};
	});
</script>

<header
	class="grid-container z-50 fixed top-0 left-0 right-0 transition-all duration-300 bg-white"
	class:-translate-y-full={!isVisible}
	class:shadow-md={showShadow}
	bind:clientHeight={headerHeight}
>
	<div class="flex flex-col lg:flex-row w-full container-whole lg:gap-10">
		<div class="flex items-center justify-between p-1 sm:py-4 sm:px-3 lg:px-0 lg:py-5">
			<Link aria-label="Logo" class="hover:opacity-100" href={getHomepagePath(tenant.locale)}>
				<Icon class={["w-auto h-7 sm:h-6 lg:w-[5.0419rem] lg:h-10 lg:mb-2"]} icon={logo} />
			</Link>
			<div class="lg:hidden flex gap-1.5">
				<Button
					variant={ButtonVariant.Transparent}
					aria-label="Menu"
					class="duration-300 transition-all p-2"
					onclick={(): void => {
						mobileMenuOpen = !mobileMenuOpen;
						lockScroll.lock = mobileMenuOpen;
					}}
				>
					<Icon class="w-8 sm:w-7" square icon={mobileMenuOpen ? closeIcon : menuIcon} />
				</Button>
			</div>
		</div>

		<Menu bind:mobileOpen={mobileMenuOpen} items={menu} {headerHeight} />
	</div>
</header>
